<!-- eslint-disable max-lines -->
<template>
    <paper class="dispatch-center">
        <el-main v-loading="mainLoading" class="main-loading">
            <m-pane
                ref="tablePage"
                :config="config"
                :totalData="totalData"
                :totalTargetData="totalTargetData"
                :sourceRootData="sourceTree"
                :mulSourceSel="true"
                :targetRootData="targetTree"
                :pageTotal="pageTotal"
                :searchTotalTitle="searchTotalTitle"
                :optionNum="optionNum"
                :loading="loading"
                :targetTableLoading="targetTableLoading"
                :verification="verification"
                :sourceTitle="sourceTitle"
                :sourceCount="sourceCount"
                :targetTitle="targetTitle"
                :endMoveHeight="endMoveHeight"
                :columnNum="columnNum"
                :isRefreshTarget="true"
                searchId="dispatch_center_query"
                pageID="dispatch_center"
                @check-btn="reserveClick"
                @getTableConfigList="getTableConfigList"
                @allocate-btn="allocateBtn"
                @searchChange="searchChange"
                @root-click="rootClick"
                @source-select-change="sourceSelChange"
                @target-select-change="targetSelChange"
                @search-input="searchInput"
                @sourceCellDblclick="sourceCellDblclick"
                @targetCellDblclick="targetCellDblclick"
                @targetRowClick="targetRowClick"
                @targetSelect="targetSelect"
                @targetSelectAll="targetSelectAll"
                @sourceSelect="sourceSelect"
                @sourceRowClick="sourceRowClick"
                @sourceSelectAll="sourceSelectAll"
                @refreshTarget="refreshTargetList"
            >
                <span slot="search-list-advance-right">
                    <el-button type="primary"
                               class="mgl-10"
                               @click="goToMapLayout">可视化排车</el-button>
                    <span
                        v-show="checkedSourceList.length"
                        class="left-info collect"
                    >
                        <span
                            >单量：<span class="content">{{
                                filterCheckedSourceListCount
                            }}</span></span
                        >
                        <span
                            >数量：<span class="content">{{
                                taskTotalCount
                            }}</span></span
                        >
                        <span
                            >方量(m³)：<span class="content">{{
                                taskTotalVolume
                            }}</span></span
                        >
                        <span
                            >重量(KG)：<span class="content">{{
                                taskTotalWeight
                            }}</span></span
                        >
                        <span v-show="totalPkgQtys"
                            >总包件数：<span class="content">{{
                                totalPkgQtys
                            }}</span></span
                        >
                    </span>
                </span>
                <div slot="table-module-btn" class="table-module-btn">
                    <reportExport
                        #default="{ submit }"
                        reportCode="REPORT-OTP-DISPATCH-DISPATCH"
                    >
                        <el-tooltip
                            effect="dark"
                            content="导出"
                            placement="bottom"
                        >
                            <span v-has="'otp04010011'">
                                <el-button
                                    icon="icon-daochu"
                                    size="mini"
                                    @click="exportFile(submit)"
                                ></el-button>
                            </span>
                        </el-tooltip>
                    </reportExport>
                    <!-- 紧急处理几百条数据的口子 -->
                    <div class="wangyan">
                        <el-input
                            v-model="emergencyMaxNum"
                            @change="emergencyMaxNumChange"
                        ></el-input>
                    </div>
                    <header-btn
                        :checkedSourceList="realCheckedSourceList"
                        @refreshList="refreshList"
                    ></header-btn>
                </div>
                <div
                    slot="target-table-header"
                    class="target-table-header"
                    @mousedown.stop.prevent="mousedownTabelHeight"
                >
                    <DispaHeader
                        :tarSelRoot="tarSelRoot"
                        :mulTotalData="mulTotalData"
                        :realTotalTargetData="realTotalTargetData"
                        :totalTargetData="totalTargetData"
                        :cheList="realCheList"
                        :checkedSourceList="realCheckedSourceList"
                        :transDisable="transferDisable"
                        :confDisable="confirmDisable"
                        :flag="flag"
                        :groupPolicyCode="groupPolicyCode"
                        :groupPolicyValArr="groupPolicyValArr"
                        :sourceTree="sourceTree"
                        :currWarehouseGroup="currWarehouseGroup"
                        :currInOutType="currInOutType"
                        :appointmentSiteCodeWhiteList="appointmentSiteCodeWhiteList"
                        @newDispOrder="newDispOrder"
                        @leftList="leftList"
                        @intelArr="intelliArrange"
                        @arraVisi="arraVisi"
                        @arrangeConfirmOk="arrangeConfirmOk"
                        @totalDataChange="totalDataChange"
                    >
                    </DispaHeader>
                </div>
                <div slot="expand-table-cont" slot-scope="{ expandTable }">
                    <expand-table-content
                        :contentTableData="expandTable"
                        :columnsList="expandTableHeader"
                    ></expand-table-content>
                </div>
            </m-pane>
        </el-main>
        <car-scheduling-dialog
            :carrierDisabled="carrierDisabled"
            :taskDataList="taskDataList"
            ref="carScheduling"
            label-position="right"
            :RwCarVisiable.sync="arrangeSubmVisi"
            v-if="arrangeSubmVisi"
            :inOutType="currInOutType"
            @AdmittOk="arrangeSubmOk"
        >
        </car-scheduling-dialog>
        <distribution
            v-if="tableVisible"
            :tableVisible.sync="tableVisible"
            :rowData="rowData"
            ref="distributionRef"
            @distributionOk="distributionOk"
        ></distribution>
        <reserve
            ref="reserve"
            :appointmentData="appointmentData"
            :showTimePick="appointmentParams.businessMode === 'B2B'"
            @closeDialog="closeReserve"
        ></reserve>
         <!-- 快销预排车 -->
        <quick-cancellation-dialog
            :quickCancellationVisiable.sync="quickCancellationVisiable"
            v-if="quickCancellationVisiable"
            :flag="flag"
            :taskDataList="taskDataList"
            @AdmittOk="arrangeSubmOk"
        >
        </quick-cancellation-dialog>
    </paper>
</template>
<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import _ from 'lodash';
import dayjs from 'dayjs';
import { Sortable } from 'sortablejs';
import mPane from '../../../components/mPanel';
import config from './dispCenterConfig.json';
import paper from '@/components/core/paper/Paper';
import ExpandTableContent from '../components/dispatchCenter/ExpandTableContent';
import { dictWithUrl } from '@/components/lots/api.js';
import {
    getSourceRoot,
    getSourceData,
    getTargetRoot,
    getTargetData,
    saveCarArrange,
    getTransferData,
    intelligentDispatch,
    appointment,
    promptTrackType,
    getWhiteListApi
} from '../../../api/dispatchCenter';
import { searchTaskOrderDetails } from '../../../api/taskCenter';
import carSchedulingDialog from '../../../components/dialog/carSchedulingDialog';
import QuickCancellationDialog from '../../../components/dialog/QuickCancellationDialog';
import { groupPolicyObj, rowCarCheck, addOrderCheck, verifyLBX, verifyLBXOrder, getMesTip, minusVerifyLBXOrder, sortTaskList } from '../../../utils/dispatchCenter.js';
import Distribution from './dialog/Distribution';
import DispaHeader from './DispaHeader';
import reportExport from '@/components/lots/reportExportPlugin';
import HeaderBtn from './HeaderBtn.vue';
import formatTime from '@/utils/common.js';
import reserve from '../../../components/reserve';
import { mapState } from 'vuex';
import bigDataLog from '@/utils/bigDataLog';

const PRIVILEGE_MOVE_CODE = 'otp040100016';
const MAX_SHOW_COUNT = 500; // 默认表格最多只给他展示500条
const TARGER_TABLE_MAX_SHOW_COUNT = 500; // 下面表格给他最多展示的数量
const DISPATCH_STATUS_IN_TRANSIT = 40; // 发车单状态-在途

export default {
    name: 'dispatchCenter',
    components: { mPane, paper, carSchedulingDialog, ExpandTableContent, Distribution, DispaHeader, reserve, reportExport, HeaderBtn, QuickCancellationDialog },
    data () {
        return {
            revocationShow: false,
            appointmentData: {},
            appointmentParams: {},
            carrierDisabled: false,
            reserveVisible: false,
            checkedSourceList: [],
            cheList: [],
            flag: '',
            currentRow: null,
            allocateData: [],
            tableVisible: false,
            tempTargetTree: [],
            config: config,
            loading: false,
            groupPolicy: '',
            groupPolicyCode: '',
            groupPolicyValArr: [],
            targetTableLoading: false,
            sourceTitle: '待调度',
            sourceCount: '0单 | 0台/0KG | 0m³',
            sourceTree: [],
            targetTree: [],
            sourceSelectedRoot: {},
            tarSelRoot: {},
            targetCanSort: true,
            optionNum: 'DELIVERY_TYPE,TRANSPORT_STATUS,OTP_TMS_PROCUREMENT_CHANNEL',
            totalData: [], // 页面展示的上表格数据
            mulTotalData: [], // 真正的上表格数据
            totalDataFirst: [],
            totalTargetData: [], // 下表格数据
            realTotalTargetData: [], // 真正的下表格数据
            targetIsAllSel: false, // 下表格是否点击全选，因为有天猫优品勾选一单选中所有相同客户订单号只展示100单判断真实选中会不准确
            sourceIsAllSel: false, // 同上，上表格类似逻辑
            pageTotal: 100,
            emergencyMaxNum: '',
            searchParams: {},
            searchTotalTitle: config.table.searchTotalTitle,
            arrangeSubmVisi: false,
            arrangeForm: { procurementChannel: '' },
            verification: {},
            expandTableHeader: [
                { label: '客户商品编码', prop: 'customerItemCode', width: 120 }, { label: '商品编码', prop: 'itemCode', width: 120 },
                { label: '名称', prop: 'itemName', width: 180 }, { label: '商品分类名称', prop: 'itemClassName', width: 180 }, { label: '货物状态', prop: '_itemStatus', width: 80 }, { label: '预计发数量', prop: 'unitQty', width: 100 },
                { label: '商品重量', prop: 'weight', width: 100 }, { label: '商品方量', prop: 'volume', width: 100 }
            ],
            startMove: 0,
            endMove: 0,
            endMoveHeight: 0,
            rowData: {},
            mainLoading: false,
            transferDisable: false,
            confirmDisable: false,
            sourceTableDom: '',
            targetTableDom: '',
            targetTotalListPage: {
                pageNo: 1,
                pageSize: 1000000,
                total: 0
            },
            targetTotalListParams: {
                dispatchStatus: '0,6,10,20,30'
            },
            columnNum: 35,
            currentSelectRow: {},
            currentSourceSelectRow: {},
            timerAllDiff: '',
            timerDragLoad: '',
            timerUpDrag: '',
            timerUpBtn: '',
            timerFinalDeliveryType: '',
            exportParams: {},
            isFirstSearch: true,
            taskDataList:[],
            quickCancellationVisiable: false, // 快销排车显隐
            appointmentSiteCodeWhiteList: []// 预约强控白名单
        };
    },
    computed: {
        ...mapState({
            supplier: state => state.supplier,
            currentTenant: state => state.currentTenant
        }),
        realCheckedSourceList: function () {
            if (this.checkedSourceList.length === this.totalData.length && this.sourceIsAllSel) {
                return this.mulTotalData;
            }
            return minusVerifyLBXOrder(this.checkedSourceList, this.mulTotalData);
        },
        realCheList: function () {
            if (this.cheList.length === this.totalTargetData.length && this.targetIsAllSel) {
                return this.realTotalTargetData;
            }
            return minusVerifyLBXOrder(this.cheList, this.realTotalTargetData);
        },
        taskTotalVolume: function () {
            return this.realCheckedSourceList.reduce((partical, value) => {
                const taskTotalVolume = partical + (value.totalVolume || 0);
                return Math.round(taskTotalVolume * 1000000) / 1000000;
            }, 0);
        },
        taskTotalWeight: function () {
            return this.realCheckedSourceList.reduce((partical, value) => {
                const taskTotalWeight = partical + (value.totalGrossWeight || 0);
                return Math.round(taskTotalWeight * 1000) / 1000;
            }, 0);
        },
        taskTotalCount: function () {
            return this.realCheckedSourceList.reduce((partical, value) => {
                const taskTotalCount = partical + (value.totalQty || 0);
                return Math.round(taskTotalCount * 10000) / 10000;
            }, 0);
        },
        filterCheckedSourceListCount: function () {
            return this.realCheckedSourceList.length;
        },
        targetTitle: function () {
            return `待发车(${this.targetTree.length || 0})`;
        },
        currWarehouseGroup: function () {
            return this.totalTargetData[0] && this.totalTargetData[0].warehouseGroup;
        },
        currInOutType: function () {
            return this.totalTargetData[0] && this.totalTargetData[0].inOutType;
        },
        totalPkgQtys: function () {
            return this.checkedSourceList.reduce((partical, value) => {
                if (value.projectClassify === 'HL') {
                    const totalPkgQtys = partical + (value.totalPkgQty || 0);
                    return Math.round(totalPkgQtys * 1000) / 1000;
                }
            }, 0);
        },
        isPrivilege: function () { // 加入发车单/移除发车单 时使用，特权模式
            const auths = this.$_has(PRIVILEGE_MOVE_CODE);
            return auths;
        }
    },
    methods: {
        getRouteQuery () {
            const transportStatus = this.$route.query.transportStatus;
            if (transportStatus) {
                this.$router.replace({ name: 'dispatchCenter', query: {} });
            }
        },
        GetDateT (d) {
            var s;
            s = d.getYear() + 1900 + '-';
            s = s + (d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) + '-';
            s += d.getDate() < 10 ? '0' + d.getDate() : d.getDate() + '';
            return (s);
        },
        // 预约返回值
        closeReserve (val, type) {
            if (type === 'sure') {
                const { mFormData } = val;
                if (mFormData.appointTime && !mFormData.appointType) {
                    return this.$message.warning('请选择预约类型');
                }
                if (mFormData.appointType && !mFormData.appointTime) {
                    return this.$message.warning('请选择预约时间');
                }
                appointment({ ...mFormData, ...this.appointmentParams, taskNo: val.taskNo }).then(res => {
                    if (res.code === '0') {
                        this.$message.success('预约成功');
                        this.$refs.reserve.visible = false;
                    }
                });
            } else if (type === 'negative') {
                this.$refs.reserve.formData = { appointTime: this.GetDateT(new Date()) + ' 23:59:59' };
            } else {
                this.$refs.reserve.visible = false;
            }
        },
        // 预约按钮
        reserveClick (data) {
            this.$refs.reserve.formData = { appointTime: this.GetDateT(new Date()) + ' 23:59:59' };
            this.$refs.reserve.showDialog();
            searchTaskOrderDetails({ taskNo: data.taskNo }).then(res => {
                if (res.code === '0') {
                    const d = res.data;
                    this.appointmentParams.orderCode = d.orderNo;
                    this.appointmentParams.businessMode = d.businessMode;
                    this.$refs.reserve.dialogs.dialogForm.inputList.map(
                        item => {
                            if (['appointTime', 'appointReason', 'appointType', 'secendAppointReason'].includes(item.value)) {
                                item.readOnly = true;
                            }
                            if (d.businessMode === 'B2C') {
                                if (['appointTime', 'appointType'].includes(item.value)) {
                                    item.readOnly = false;
                                }
                            } else {
                                if (['appointReason', 'appointType', 'secendAppointReason'].includes(item.value)) {
                                    item.readOnly = false;
                                }
                            }
                            if (item.value === 'appointType') {
                                if (d.orderInfo.orderStatus >= 350) {
                                    item.options = [{ 'label': '配送预约', 'value': 'DELEIVERY_APPOINTMENT' }];
                                } else {
                                    item.options = [{ 'label': '仓内预约', 'value': 'WH_APPOINTMENT' }];
                                }
                            }
                        }
                    );
                    const obj = {};
                    obj.taskNo = d.taskNo;
                    obj.customerOrderNo = d.customerOrderNo;
                    const addr = `${d.taskAddress.finalProvinceName}${d.taskAddress.finalCityName}${d.taskAddress.finalDistrictName}${d.taskAddress.finalTownName}${d.taskAddress.finalDetailAddr}`;
                    obj.receiveMessage = `${d.taskAddress.finalName}/${d.taskAddress.finalMobile}/${addr}`;
                    obj.expectTime = d.expectArriveEndTime
                        ? `${d.expectArriveStartTime}~${d.expectArriveEndTime}`
                        : d.expectArriveStartTime;
                    this.appointmentData = obj;
                }
            });
        },
        refreshList (visiable) {
            if (visiable) { this[visiable] = false; }
            this.$refs.tablePage.$refs.searchList.onSearchChange();
        },
        leftList () {
            this.totalData = [];
            this.totalTargetData = [];
            this.mulTotalData = [];
            this.realTotalTargetData = [];
            this.$refs.tablePage.$refs.searchList.onSearchChange();
        },
        async getDictList () {
            await dictWithUrl(this.optionNum);
        },
        async initTableData (initData) {
            const dict = await dictWithUrl('OTP_TMS_PROCUREMENT_CHANNEL,TRANSPORT_STATUS,ORDER_TYPE,DELIVERY_TYPE,PROJECT_CLASSIFY,TASK_TYPE,SOURCE_SYSTEM,WMS_STATUS,TMS_SHIPPING_TYPE,ORDER_SERVICE_TYPE');
            const dictData = dict.data;
            initData.forEach(item => {
                item.hiddenEvent = [];
                item.sourceSystemName = dictData.SOURCE_SYSTEM[item.sourceSystem] || item.sourceSystem;
                item.serviceTypeName = dictData.ORDER_SERVICE_TYPE[item.serviceType] || item.serviceType;
                item.supplierReserveFlagName = item.supplierReserveFlag === 'Y' ? '是' : '否';
                item.procurementChannelName = dictData.OTP_TMS_PROCUREMENT_CHANNEL[item.procurementChannel] || item.procurementChannel;
                item.distributionFlagName = item.distributionFlag === 'Y' ? '是' : '否';
                item.distributionContinueFlagName = item.distributionContinueFlag === 'Y' ? '是' : '否';
                item.carrierVisibleFlagName = item.carrierVisibleFlag === 'Y' ? '是' : '否';
                item.collectionFlagName = item.collectionFlag === 'Y' ? '是' : '否';
                item.isJzpName = item.isJzp === 'Y' ? '是' : '否';
                item.deliverypayTypeName = +item.deliverypayType === 2 ? '到付' : '寄付';
                item.scPosFlagName = +item.scPosFlag === 0 ? '否' : (+item.scPosFlag === 1 ? '是' : item.scPosFlag);
                item.cnDispatchName = +item.cnDispatch === 0 ? '否' : (+item.cnDispatch === 1 ? '是' : item.cnDispatch);
                item.intelligentStatusName = +item.intelligentStatus === 0 ? '未智能调度' : (+item.intelligentStatus === 1 ? '智能调度成功' : '智能调度失败');
                item.planOrderFlagName = +item.planOrderFlag === 1 ? '是' : '否';
                item.timePriorityName = +item.timePriority === 1 ? '是' : '否';
                item.b2cZpFlagName = +item.b2cZpFlag === 1 ? '是' : +item.b2cZpFlag === 0 ? '否' : '';
                item.logisticModeName = item.logisticMode === 'WT' ? '是' : '否';
                item.taskStatusName = dictData.TRANSPORT_STATUS[item.taskStatus] || item.taskStatus;
                item.orderTypeName = dictData.ORDER_TYPE[item.orderType] || item.orderType;
                item.deliveryTypeName = dictData.DELIVERY_TYPE[item.deliveryType] || item.deliveryType;
                item.projectClassifyName = dictData.PROJECT_CLASSIFY[item.projectClassify] || item.projectClassify;
                item.taskTypeName = dictData.TASK_TYPE[item.taskType] || item.taskType;
                item.sourceSystemName = dictData.SOURCE_SYSTEM[item.sourceSystem] || item.sourceSystem;
                item.shippingTypeName = dictData.TMS_SHIPPING_TYPE[item.shippingType] || item.shippingType;
                item.appointmentFlagName = item.appointmentFlag === 1 ? '是' : '否';
                item.entityId = item.entityId ? item.entityId + '' : '';
                item.wmsStatusName = dictData.WMS_STATUS[item.wmsStatus] || '待作业';
                if (item.transportDetails && item.transportDetails.length > 0) {
                    const splitArr = item.transportDetails[0].itemClassName ? item.transportDetails[0].itemClassName.split('.') : [];
                    splitArr.shift();
                    item.itemClassName = splitArr.join('.');
                };
                item.arriveAppointmentRequireFlagName = +item.arriveAppointmentRequireFlag === 3 ? '是' : '否';
                item.directControlFlagName = +item.directControlFlag === 1 ? '是' : '否';
                item.vipFlag = (item.vipFlag !== undefined && item.vipFlag !== null) ? `${item.vipFlag}` : item.vipFlag;
            });
            return initData;
        },
        initDispatchList () {
            if (+this.tarSelRoot.intelligentStatus === 10) this.$refs.tablePage.$refs.searchList.onSearchChange();
            this.$refs.tablePage.targetLoading = true;
            const params = { dispatchNo: this.tarSelRoot.dispatchNo, ...this.targetTotalListPage };
            getTargetData(params).then(async res => {
                if (res) {
                    this.realTotalTargetData = await this.initTableData(sortTaskList(res.data.list || []));
                    this.totalTargetData = this.getTotalData(this.realTotalTargetData, TARGER_TABLE_MAX_SHOW_COUNT);
                }
            }).finally(() => {
                this.$refs.tablePage.targetLoading = false;
            });
        },
        initTransportList (scroll) {
            this.$refs.tablePage.sourceLoading = true;
            const data = Object.assign({}, this.searchParams, { pageSize: 1000 });
            groupPolicyObj.forEach(item => {
                if (item.name === this.groupPolicy) {
                    this.groupPolicyCode = item.code;
                    data[item.code] = this.sourceSelectedRoot[item.code] || '';
                }
            });
            getSourceData(data).then(async resp => {
                this.$refs.tablePage.sourceLoading = false;
                if (resp) {
                    this.sourceSelectedRoot.isActive = !this.sourceSelectedRoot.isActive;
                    const resData = resp.data.list || [];
                    if (this.sourceSelectedRoot.isActive) {
                        this.mulTotalData = this.mulTotalData.concat(resData);
                    } else {
                        const resDataGroupPolicyCode = resData.map(el => el[this.groupPolicyCode]);
                        this.mulTotalData = this.mulTotalData.filter(el => !resDataGroupPolicyCode.includes(el[this.groupPolicyCode]));
                    }
                    // let btnCount = 0;
                    let btnFlag = false;
                    const totalTargetDataTaskNo = this.realTotalTargetData.map(el => el.taskNo);
                    this.mulTotalData = this.mulTotalData.filter(el => !totalTargetDataTaskNo.includes(el.taskNo));
                    this.mulTotalData = await this.initTableData(sortTaskList(this.mulTotalData));
                    this.mulTotalData.forEach((subItem, subIndex) => {
                        subItem.hiddenEvent = [];
                        if (subItem.supplierReserveFlag !== 'Y') {
                            subItem.hiddenEvent.push('view');
                        }
                        if (subItem.businessMode === 'B2C' && subItem.taskStatus >= 70) {
                            subItem.hiddenEvent.push('view');
                        }
                        const isTrue = subItem.taskStatus >= 40 || (subItem.deliveryType === 'NET' && subItem.distributionFlag === 'Y' && subItem.distributionNum === 1);
                        if (subItem.businessMode === 'B2B' && isTrue) {
                            subItem.hiddenEvent.push('view');
                        }
                        if ((subItem.orderType === 'RI') && ['IN', 'DI', 'RDI'].includes(subItem.taskType)) {
                            // subItem.hiddenEvent = ['allocate'];
                            subItem.hiddenEvent.push('allocate');
                        } else {
                            // btnCount++;
                            // subItem.hiddenEvent = [];
                        }
                        if (subItem.hiddenEvent.length < 3) {
                            btnFlag = true;
                        }
                    });
                    this.config.table.leftOperation = btnFlag;
                    this.totalData = this.getTotalData(this.mulTotalData);
                }
            }).catch(() => {
                this.$refs.tablePage.sourceLoading = false;
            });
        },
        rowDrop () {
            const sourceTbody = document.querySelector(
                '.source-table .el-table__body-wrapper tbody'
            );
            const _this = this;
            this.sortInst = Sortable.create(sourceTbody, {
                group: {
                    name: 'source',
                    pull: true,
                    put: 'target' // 可拖出
                },
                sort: false, // 禁止表内排序
                multiDrag: true,
                onEnd: ({ newIndex, oldIndex, from, to, item }) => {
                    const oldSourceInx = oldIndex;
                    if (from !== to) {
                        // 处理展开详情index顺序乱掉问题
                        if (item.className === '') {
                            oldIndex = oldSourceInx - 1;
                        } else {
                            const trs = from.getElementsByTagName('tr');
                            let trIndex = '';
                            for (let i = 0; i < trs.length; i++) {
                                if (trs[i].className === '') {
                                    trIndex = i;
                                }
                            }
                            if (trIndex === '') {
                                oldIndex = oldSourceInx;
                            } else if (trIndex < oldIndex) {
                                oldIndex = oldSourceInx - 1;
                            }
                        }
                        item.remove();
                        const rows2Transfer = _this.realCheckedSourceList.length > 1 ? _this.realCheckedSourceList : [_this.totalData[oldIndex]];
                        const clone = _this.totalData;
                        _this.totalData = [];
                        for (let i = 0; i < rows2Transfer.length; i++) {
                            let warningMsg = '';
                            if (this.isPrivilege && rows2Transfer[i].logisticMode === 'WT' && rows2Transfer[i].scanNum > 0 && +rows2Transfer[i].dispatchType !== 0) {
                                warningMsg = '直通宝已扫码，请在直通宝完成后续操作';
                            }
                            if (warningMsg) {
                                _this.timerAllDiff = setTimeout(() => {
                                    _this.$nextTick(() => {
                                        _this.totalData = clone;
                                    });
                                }, 100);
                                return this.$message.warning(warningMsg);
                            }
                        }
                        const realTotalData = this.mulTotalData;
                        let rowCarCheckRes = '';
                        const verifyLBXRes = verifyLBX(rows2Transfer, realTotalData);
                        clearTimeout(_this.timerAllDiff);
                        clearTimeout(_this.timerDragLoad);
                        if (_this.realTotalTargetData.length <= 0) {
                            rowCarCheckRes = rowCarCheck(rows2Transfer);
                        } else {
                            rowCarCheckRes = rowCarCheck(_this.realTotalTargetData);
                            if (!rowCarCheckRes) rowCarCheckRes = rowCarCheck(rows2Transfer, _this.realTotalTargetData[0], _this.realTotalTargetData);
                            if (!rowCarCheckRes) rowCarCheckRes = addOrderCheck(_this.realTotalTargetData, rows2Transfer);
                        }
                        _this.timerAllDiff = setTimeout(() => {
                            _this.$nextTick(() => {
                                if (rowCarCheckRes) {
                                    _this.totalData = clone;
                                    return _this.$message.warning(rowCarCheckRes);
                                } else if (_.isPlainObject(verifyLBXRes)) {
                                    _this.totalData = clone;
                                    return getMesTip(verifyLBXRes, _this);
                                } else {
                                    _this.realTotalTargetData = [
                                        ...verifyLBXRes,
                                        ..._this.realTotalTargetData
                                    ];
                                    _this.totalTargetData = this.getTotalData(_this.realTotalTargetData, TARGER_TABLE_MAX_SHOW_COUNT);
                                    const transTaskNo = verifyLBXRes.map(el => el.taskNo);
                                    this.mulTotalData = this.mulTotalData.filter(el => !transTaskNo.includes(el.taskNo));
                                    _this.totalData = this.getTotalData(this.mulTotalData);
                                }
                            });
                        }, 100);
                    }
                }
            });
            const targetTbody = document.querySelector(
                '.target-table .el-table__body-wrapper tbody'
            );
            Sortable.create(targetTbody, {
                group: {
                    name: 'target',
                    pull: true,
                    put: 'source' // 可放置来自source组的拖拽
                },
                sort: false,
                multiDrag: true,
                onEnd: ({ newIndex, oldIndex, from, to, item }) => {
                    const oldTargetInx = oldIndex;
                    this.groupPolicyValArr = [];
                    if (from !== to) {
                        // 处理展开详情index顺序乱掉问题
                        if (item.className === '') {
                            oldIndex = oldTargetInx - 1;
                        } else {
                            const trs = from.getElementsByTagName('tr');
                            let trIndex = '';
                            for (let i = 0; i < trs.length; i++) {
                                if (trs[i].className === '') {
                                    trIndex = i;
                                }
                            }
                            if (trIndex === '') {
                                oldIndex = oldTargetInx;
                            } else if (trIndex < oldIndex) {
                                oldIndex = oldTargetInx - 1;
                            }
                        }
                        const targetTabelData = _this.realCheList.length > 1 ? _this.realCheList : [_this.totalTargetData[oldIndex]];
                        const targetClone = _this.totalTargetData;
                        _this.totalTargetData = [];
                        clearTimeout(this.timerUpDrag);
                        this.timerUpDrag = setTimeout(() => {
                            _this.$nextTick(() => {
                                if (+this.tarSelRoot.gainingContract) {
                                    _this.$message.warning('获取合同号中，不可以加单');
                                    _this.totalTargetData = targetClone;
                                } else {
                                    for (let i = 0; i < targetTabelData.length; i++) {
                                        if (targetTabelData[i].logisticMode !== 'WT' +targetTabelData[i].taskStatus === 30 && targetTabelData[i].dispatchNo && ['YS', 'OUT'].includes(targetTabelData[i])) {
                                            _this.totalTargetData = targetClone;
                                            return this.$message.warning(`存在不能减单的运输单：${targetTabelData[i].taskNo}`);
                                        }
                                        if (this.isPrivilege && targetTabelData[i].logisticMode === 'WT' && targetTabelData[i].taskStatus >= DISPATCH_STATUS_IN_TRANSIT) {
                                            return this.$message.warning(`仓配分离运输单：${targetTabelData[i].taskNo} 是在途前的状态才能减单`);
                                        }
                                    }
                                    const minusVerifyLBXOrderRes = minusVerifyLBXOrder(targetTabelData, this.realTotalTargetData);
                                    const targetDataTaskNo = minusVerifyLBXOrderRes.map(el => el.taskNo);
                                    this.realTotalTargetData = this.realTotalTargetData.filter(el => !targetDataTaskNo.includes(el.taskNo));
                                    _this.totalTargetData = this.getTotalData(this.realTotalTargetData, TARGER_TABLE_MAX_SHOW_COUNT);
                                    const currentGroupPolicyData = []; // 在当前分组下要拖的数据
                                    this.groupPolicyValArr = [];
                                    // 多选功能下选中的待调度的分组
                                    this.sourceTree.forEach(item => {
                                        if (item.isActive) this.groupPolicyValArr.push(item[this.groupPolicyCode]);
                                    });
                                    minusVerifyLBXOrderRes.forEach(item => {
                                        if (this.groupPolicyValArr.includes(item[this.groupPolicyCode])) currentGroupPolicyData.push(item);
                                    });
                                    const curGrototalDataClone = [].concat(_this.mulTotalData);
                                    const targetTabelTask = curGrototalDataClone.map(el => el.taskNo);
                                    currentGroupPolicyData.forEach(item => {
                                        if (this.groupPolicyValArr.length === 0) {
                                            _this.mulTotalData = [];
                                        } else if (this.groupPolicyValArr.includes(item[this.groupPolicyCode]) && !targetTabelTask.includes(item.taskNo)) {
                                            _this.mulTotalData.unshift(item);
                                        }
                                    });
                                    _this.totalData = this.getTotalData(_this.mulTotalData);
                                }
                            });
                        }, 80);
                    }
                }
            });
        },
        _validateSearchParams (data) {
            this._validateFailed = false;
            const startTime = data.beginDate || 0;
            const endTime = data.endDate || 0;
            const timeDifference = new Date(endTime).getTime() - new Date(startTime).getTime();
            if (!data.custOrderNos.length && !startTime) {
                this.$message.warning('客户订单号 和 创建时间 不可同时为空');
                this._validateFailed = true;
            } else if (!data.custOrderNos.length && startTime) {
                if (timeDifference > 63 * 24 * 60 * 60 * 1000) {
                    this.$message.warning('按时间查询或导出时，查询或导出时间跨度不可超过两个月！');
                    this._validateFailed = true;
                }
            }
        },
        getTotalData (totalData, maxShowCount = MAX_SHOW_COUNT) {
            const maxCountNum = this.emergencyMaxNum || maxShowCount;
            if (totalData.length < maxCountNum) {
                return totalData;
            }
            return totalData.slice(0, maxCountNum);
        },
        emergencyMaxNumChange (value) {
            this.leftList();
            this.emergencyMaxNum = value;
        },
        async searchChange (data) {
            if (data.createTime && data.createTime.length > 0) {
                data.beginDate = formatTime.formatDateTime(data.createTime[0]);
                data.endDate = formatTime.formatDateTime(data.createTime[1]);
            } else if (!data.createTime && !data.beginDate) {
                data.beginDate = '';
                data.endDate = '';
            }
            if (data.departureTime && data.departureTime.length > 0) {
                data.beginDate1 = data.departureTime[0];
                data.endDate1 = data.departureTime[1];
            } else if (!data.departureTime && !data.beginDate1) {
                data.beginDate1 = '';
                data.endDate1 = '';
            }
            if (data.requireArriveTime && data.requireArriveTime.length > 0) {
                data.requireArriveTimeBegin = data.requireArriveTime[0];
                data.requireArriveTimeEnd = data.requireArriveTime[1];
            } else if (!data.requireArriveTime && !data.requireArriveTimeBegin) {
                data.requireArriveTimeBegin = '';
                data.requireArriveTimeEnd = '';
            }
            if (data.requireOutTime && data.requireOutTime.length > 0) {
                data.requireOutTimeStart = data.requireOutTime[0];
                data.requireOutTimeEnd = data.requireOutTime[1];
            } else if (!data.requireOutTime && !data.requireOutTimeStart) {
                data.requireOutTimeStart = '';
                data.requireOutTimeEnd = '';
            }
            if (data.custOrderNo) {
                data.custOrderNos = data.custOrderNo.split(',');
            } else {
                data.custOrderNos = [];
            }
            if (data.waveId) {
                data.waveIdList = data.waveId.split(',');
            } else {
                data.waveIdList = '';
            }
            if (data.waveIdList.length > 100) {
                return this.$message.warning('最多只允许操作100个波次号进行查询')
            }
            if (data.zoneNamesStr && data.zoneNamesStr.split(',').length > 10) {
                return this.$message.warning('最多只能选择10个库区！');
            }

            // 目的地选择地址处理
            [
                'receiverProvinceCode',
                'receiverCityCode',
                'receiverDistrictCode',
                'receiverTownCode'
            ].forEach(code => {
                    if (data[code]) {
                        data[`${code}s`] = data[code].split(',');
                    } else {
                        delete this.searchParams[`${code}s`];
                        delete data[`${code}s`];
                    }
                    delete data[code];
                });

            delete data.waveId;
            delete data.custOrderNo;
            delete data.createTime;
            delete data.departureTime;
            delete data.requireArriveTime;
            delete data.requireOutTime;
            delete data.cpName;
            this._searchData = data;
            this._validateSearchParams(this._searchData);
            if (this._validateFailed) return false;
            this.totalData = [];
            this.mulTotalData = [];
            // this.totalTargetData = [];
            if (data.groupPolicy) this.groupPolicy = data.groupPolicy;
            data.taskStatus = '0';
            this.searchParams = {
                ...this.searchParams,
                ...data
            };
            if (this.searchParams.querySiteCode) {
                this.searchParams.querySiteCodes = this.searchParams.querySiteCode.split(',');
            } else {
                this.searchParams.querySiteCodes = [];
            }
            if (this.searchParams.vipFlagList && !this.searchParams.vipFlagList.length) delete this.searchParams.vipFlagList;
            this.searchParams.queryCustomerCodeList = this.searchParams.customerCode ? this.searchParams.customerCode.split(',') : '';
            this.searchParams['carrierVisibleFlag'] = 'Y';
            this.searchParams['carrierCode'] = this.supplier.supplierCode;
            this.exportParams = { ...this.searchParams };
            this.getRouteQuery();
            this.$refs.tablePage.changeLoading(true);
            this.$refs.tablePage.sourceTreeLoading = true;
            this.$refs.tablePage.targetTreeLoading = true;
            await getSourceRoot(this.searchParams).then(resp => {
                this.$refs.tablePage.changeLoading(false);
                this.$refs.tablePage.sourceTreeLoading = false;
                if (resp) {
                    const sourceTree = resp.data.list;
                    let totalQty = 0
                    let taskCount = 0
                    let totalWeight = 0
                    let totalVolume = 0
                    if (sourceTree) {
                        sourceTree.forEach(root => {
                            root.isActive = false;
                            totalQty += Math.round(root.totalQty * 10000) / 10000;
                            taskCount += root.taskCount;
                            totalWeight += root.totalWeight;
                            totalVolume += root.totalVolume;
                            root['textLeft'] =
                                `${root[this.groupPolicy] ? root[this.groupPolicy] : ' '} ${root.totalVolume || ''}m³/${root.totalWeight || ''}KG/${root.totalQty || ''}台/${root.taskCount || ''}单`;
                        });
                    }
                    this.sourceTree = sourceTree;
                    this.sourceCount = `${ taskCount }单 | ${ totalQty }台/${totalWeight ? totalWeight.toFixed(2) : 0 }KG | ${ totalVolume ? totalVolume.toFixed(2) : 0 }m³`;
                }
            }).catch(() => {
                this.$refs.tablePage.changeLoading(false);
                this.$refs.tablePage.sourceTreeLoading = false;
            });
            await this.getTargetList();
            this.$refs.tablePage.initActiveChange();
        },
        async getTargetList (isClick) {
            this.$refs.tablePage.targetTreeLoading = true;
            this.targetTotalListParams.carrierCode = this.supplier.supplierCode;
            await getTargetRoot(this.targetTotalListParams).then(res => {
                this.$refs.tablePage.targetTreeLoading = false;
                if (res) {
                    const targetTree = res.data.list || [];
                    if (targetTree) {
                        targetTree.forEach(root => {
                            if (+root.intelligentFlag !== 0) {
                                if (+root.intelligentStatus === 10) {
                                    root['html'] = `<span class="left-doted"> 智能排车中...`;
                                } else {
                                    root['html'] = `<span class="left-doted">${root.vehicleCard} ${root.volume}m³/${root.totalWeight}KG/${Math.round(root.loadRate * 100)}%`;
                                }
                            } else {
                                root['html'] = `${root.vehicleCard} ${root.volume}m³/${root.totalWeight}KG/${Math.round(root.loadRate * 100)}%`;
                            }
                        });
                    }
                    this.targetTree = this.tempTargetTree = targetTree;
                    if (isClick) {
                        this.$nextTick(() => {
                            this.targetTree[0] && this.$refs.tablePage.rootListClick(this.targetTree[0], 'target', 0);
                        });
                    }
                    setTimeout(() => {
                        this.autoSearchInput && this.autoSearchInput();
                        this.autoSearchInput = null;
                        this.againActivated = true;
                    }, 100);
                }
            }).catch(() => {
                this.$refs.tablePage.targetTreeLoading = true;
            });
        },
        getTableConfigList (data) { },
        rootClick (item, to) {
            if (to === 'source') {
                this.sourceSelectedRoot = item;
                this.initTransportList();
            }
            if (to === 'target') {
                this.tarSelRoot = item;
                if (+this.tarSelRoot.intelligentStatus === 10) {
                    this.transferDisable = this.confirmDisable = true;
                } else if (+this.tarSelRoot.intelligentStatus === 30) {
                    this.transferDisable = this.confirmDisable = false;
                }
                this.initDispatchList();
            }
        },
        sourceSelChange (selection) {
            this.checkedSourceList = selection;
            const selctedTaskNos = this.checkedSourceList.map(item => item.taskNo);
            this.currentSourceSelectRow.checked = selctedTaskNos.includes(this.currentSourceSelectRow.taskNo);
            const moduleTable = _.get(this, '$refs.tablePage.$refs.table.$refs.moduleTable', {});
            this.checkSameLbxOrder(this.currentSourceSelectRow, moduleTable);
        },
        sourceSelectAll (selection) { this.sourceIsAllSel = true; },
        sourceSelect (selection, row) {
            this.sourceIsAllSel = false;
            this.currentSourceSelectRow = row;
        },
        sourceRowClick (row) {
            this.sourceIsAllSel = false;
            const moduleTable = _.get(this, '$refs.tablePage.$refs.table.$refs.moduleTable', {});
            this.checkSameLbxOrder(row, moduleTable);
        },
        targetSelChange (selection) {
            this.cheList = selection;
            const selctedTaskNos = this.cheList.map(item => item.taskNo);
            this.currentSelectRow.checked = selctedTaskNos.includes(this.currentSelectRow.taskNo);
            const moduleTable = _.get(this, '$refs.tablePage.$refs.targetTable.$refs.moduleTable', {});
            this.checkSameLbxOrder(this.currentSelectRow, moduleTable);
        },
        targetSelect (selection, row) {
            this.targetIsAllSel = false;
            this.currentSelectRow = row;
        },
        targetSelectAll (selection) {
            this.targetIsAllSel = true;
        },
        checkSameLbxOrder (row, moduleTable) {
            // 天猫优品的单勾选一条相同客户订单号的全部选中（展示中的数据）
            if (row.businessMode === 'B2B' && ['OUT', 'DO'].includes(row.taskType) && row.sourceSystem === 'CAINIAO') {
                const sameLbxOrder = moduleTable.tableData.filter(item => item.customerOrderNo === row.customerOrderNo);
                sameLbxOrder.forEach(item => {
                    moduleTable.toggleRowSelection(item, row.checked);
                });
            }
        },
        targetRowClick (row) {
            this.targetIsAllSel = false;
            const moduleTable = _.get(this, '$refs.tablePage.$refs.targetTable.$refs.moduleTable', {});
            this.checkSameLbxOrder(row, moduleTable);
        },
        intelliArrange () {
            if (this.realTotalTargetData.length) {
                if (this.realTotalTargetData.some(el => el.isIntelliFailed)) {
                    // 智能排车失败标志
                    this.$message.warning('存在请求智能排车的失败数据，不能进行二次智能排车');
                    return;
                }
                if (this.realTotalTargetData.find(el => +el.planOrderFlag === 1)) return this.$message.warning('不支持模糊订单智能排车，有问题请联系郑右云');
                this.$refs.tablePage.targetLoading = true;
                const params = {
                    biz: 'vrp',
                    transportList: this.realTotalTargetData
                };
                intelligentDispatch(params).then(res => {
                    this.$refs.tablePage.targetLoading = false;
                    if (res) {
                        this.$message.success('已提交');
                        this.leftList();
                    }
                }).catch(() => {
                    this.$refs.tablePage.targetLoading = false;
                });
            } else {
                this.$message.warning('请至少选择一条运输单');
            }
        },
        handleArrangeClose () {
            this.arrangeSubmVisi = false;
        },
        arrangeSubmOk (data) {
            if (data.state) {
               if (data.data.preDispatchStrategy !== 'FMCG') { // 不是快消单
                    this.arrangeSubmVisi = true;
                    this.$refs.carScheduling.saveLoading = true;
                }
                if (+this.flag === 2) {
                    const obj = {
                        flag: +this.flag,
                        oldDispatchNo: this.tarSelRoot.dispatchNo,
                        dispatchStatus: this.tarSelRoot.dispatchStatus,
                        transportList: this.realCheList,
                        operateEntrance: 'LSP',
                        ...data.data
                    };
                    obj.transportList.forEach(item => {
                        item.carrierVisibleFlag = item.carrierVisibleFlag || 'N';
                    });
                    getTransferData(obj).then(res => {
                        if (obj.preDispatchStrategy !== 'FMCG') { // 不是快消单
                            this.$refs.carScheduling.saveLoading = false;
                        }
                        if (res) {
                            if (res.msg === 'Success') {
                                this.$message({
                                    dangerouslyUseHTMLString: true,
                                    message: `<div>
                                                <span>转移成功，生成发车单号：${res.data}</span>
                                                <a id="copyTraNo" href='#' style='color: #11bec1; margin-left: 20px;'>复制</a>
                                            </div>`,
                                    type: 'success',
                                    duration: 5000
                                });
                                if (obj.vehicleCard && obj.vehicleCard !== '*') {
                                    this.getPromptTrackType(res.data);
                                }
                            } else if (res.msg.includes('风控代码')) {
                                this.$confirm(`${res.msg}`, '提示', {
                                    confirmButtonText: '确定',
                                    type: 'warning',
                                    showClose: false,
                                    showCancelButton: false,
                                    closeOnClickModal: false,
                                    closeOnPressEscape: false
                                }).then(() => {
                                    const genDispatchNo = res.data.indexOf(',') < 0 ? res.data : res.data.split(',')[0];
                                    this.copyText(document.body, genDispatchNo, false);
                                });
                            } else {
                                this.$message({
                                    dangerouslyUseHTMLString: true,
                                    message: `<div>
                                                <span>${res.msg}</span>
                                                <a id="copyTraNo" href='#' style='color: #11bec1; margin-left: 20px;'>复制</a>
                                            </div>`,
                                    showClose: true,
                                    type: 'success',
                                    duration: 5000
                                });
                            }
                            const genDispatchNo = res.data.indexOf(',') < 0 ? res.data : res.data.split(',')[0];
                            this.arrangeSubmVisi = false;
                            this.quickCancellationVisiable = false;
                            document.getElementById('copyTraNo').addEventListener('click', () => {
                                this.copyText(document.body, genDispatchNo, false);
                            });
                            this.leftList();
                        }
                    }).catch(() => {
                        if (obj.preDispatchStrategy !== 'FMCG') { // 不是快消单
                            this.$refs.carScheduling.saveLoading = false;
                        }
                    });
                } else {
                    this.mainLoading = true;
                    data = Object.assign({operateEntrance: 'LSP',}, data.data, this.tarSelRoot,);
                    data.transportList = this.realTotalTargetData;
                    data.transportList.forEach(item => {
                        item.carrierVisibleFlag = item.carrierVisibleFlag || 'N';
                    });
                    saveCarArrange(data).then(res => {
                        this.mainLoading = false;
                        if (data.preDispatchStrategy !== 'FMCG') { // 不是快消单
                            this.$refs.carScheduling.saveLoading = false;
                        }
                        if (res && +res.code === 0) {
                            const genDispatchNo = res.data.indexOf(',') < 0 ? res.data : res.data.split(',')[0];
                            if (data.procurementChannel === '190') {
                                this.$router.push({
                                    name: 'dispatchOrder',
                                    params: { name: '/dispatch-order', dispatchNo: genDispatchNo, carrierName: data.carrierName }
                                });
                            }
                            this.$message({
                                dangerouslyUseHTMLString: true,
                                message: `<div>
                                    <span style="white-space: pre-line;">已保存，生成发车单号：${res.data}</span>
                                    <a id="copyNo" href='#' style='color: #11bec1; margin-left: 20px;'>复制</a>
                                </div>`,
                                type: 'success',
                                duration: 5000
                            });
                            this.arrangeSubmVisi = false;
                            this.quickCancellationVisiable = false;
                            document.getElementById('copyNo').addEventListener('click', () => {
                                this.copyText(document.body, genDispatchNo, false);
                            });
                            if (data.vehicleCard && data.vehicleCard !== '*') {
                                this.getPromptTrackType(genDispatchNo);
                            }
                            this.leftList();
                        } else if (+res.code === 200) {
                            this.arrangeSubmVisi = false;
                            this.$message.error(res.msg || '');
                            this.leftList();
                        }
                    }).catch(() => {
                        this.mainLoading = false;
                        if (data.preDispatchStrategy !== 'FMCG') { // 不是快消单
                            this.$refs.carScheduling.saveLoading = false;
                        }
                    });
                }
            }
        },
        getPromptTrackType (dispatchNo) {
            promptTrackType(dispatchNo).then(res => {
                if (res && +res.code === 0 && res.data && +res.data.shippingType === 1) {
                    if (+res.data.isZjxl === 0) {
                        this.$message.warning('该车辆不支持北斗轨迹获取，请要求司机全程打开直通宝');
                    } else if (+res.data.isZjxl === 1) {
                        this.$message.warning('该车辆可通过北斗获取轨迹');
                    } else {
                        this.$message.warning('未知车辆北斗入网状态，请要求司机全程打开直通宝');
                    }
                }
            });
        },
        searchInput (input, ev, isClick) {
            const inputVal = input.trim();
            const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
            if (!inputVal) {
                this.targetTotalListParams.dispatchNo = '';
                this.targetTotalListParams.vehicleCard = '';
            } else if (reg.test(inputVal)) {
                this.targetTotalListParams.dispatchNo = '';
                this.targetTotalListParams.vehicleCard = inputVal;
            } else {
                this.targetTotalListParams.dispatchNo = inputVal;
                this.targetTotalListParams.vehicleCard = '';
            }
            this.getTargetList(isClick);
        },
        async arrangeConfirmOk (dispatchNo) {
            this.totalData = [];
            this.totalTargetData = [];
            this.mulTotalData = [];
            this.realTotalTargetData = [];
            this.tarSelRoot = {};
            await this.searchChange(this.searchParams);
            this.$refs.tablePage.isCondition = true;
            this.$refs.tablePage.isShowImg = false;
            this.$refs.tablePage.input = dispatchNo;
            this.targetTree = this.tempTargetTree.filter(item => {
                return (item.dispatchNo && item.dispatchNo.indexOf(dispatchNo.trim()) !== -1);
            });
            if (this.targetTree.length === 0) {
                this.$refs.tablePage.input = null;
                this.targetTree = this.tempTargetTree;
            }
        },
        allocateBtn (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-allocation');
            this.rowData = Object.assign({}, data);
            const verifyLBXOrderRes = verifyLBXOrder([data]);
            if (!getMesTip(verifyLBXOrderRes, this)) { this.tableVisible = true; }
        },
        distributionOk () {
            this.tableVisible = false;
            this.$refs.tablePage.$refs.searchList.onSearchChange();
        },
        newDispOrder () {
            this.tarSelRoot = {};
            this.totalTargetData = [];
            this.realTotalTargetData = [];
        },
        arraVisi (val, dispatchStatus) {
            // val有值 是移交dialog 里面选了 新建发车单 然后点击确定按钮,这个时候taskDataList等于下表格选中的数据，否则是下表格所有的数据
            this.taskDataList = val ? this.realCheList : this.realTotalTargetData;
            this.flag = val;
            // 快销判断，特殊排车
            const QCOFlag = this.taskDataList.some(i => i.projectClassify === 'QCO');
             if (dispatchStatus) { // 已预排才显示预排界面
                if (+dispatchStatus === 6 && QCOFlag) {
                    this.quickCancellationVisiable = true;
                    return false;
                }
            } else {
                if (QCOFlag) {
                    this.quickCancellationVisiable = true;
                    return false;
                }
            }
            const setVal = () => {
                this.arrangeSubmVisi = true;
                this.carrierDisabled = true;
                const params = {
                    carrierName: this.realTotalTargetData[0].carrierName,
                    carrierCode: this.realTotalTargetData[0].carrierCode,
                    supplierCode: this.realTotalTargetData[0].carrierCode,
                    transType: this.realTotalTargetData[0].procurementChannel,
                    tranName: this.realTotalTargetData[0].procurementChannelName,
                    siteCode: this.realTotalTargetData[0].siteCode,
                    transUnitName: this.realTotalTargetData[0].transUnitName,
                    transUnitCode: this.realTotalTargetData[0].transUnitCode,
                    paymentTerms: this.realTotalTargetData[0].paymentTerms,
                    transportContractNo: this.realTotalTargetData[0].transportContractNo
                };
                this.$nextTick(() => {
                    this.$refs.carScheduling.AdmittRuleForm.carrierName = this.realTotalTargetData[0].carrierName;
                    this.$refs.carScheduling.AdmittRuleForm.companyCode = this.realTotalTargetData[0].companyCode;
                    this.$refs.carScheduling.AdmittRuleForm.routeNoList = this.realTotalTargetData.filter(item => item.lineCode).map(item => item.lineCode);
                    this.$refs.carScheduling.AdmittRuleForm.siteCodeList = this.realTotalTargetData.filter(item => item.siteCode).map(item => item.siteCode);
                    this.$refs.carScheduling.getAdvanceValueLists(params);
                });
            };
            // val有值 是移交dialog 里面选了 新建发车单 然后点击确定按钮
            // carrierVisibleFlag !== 'Y'是点了排车, 但未下发供应商
            if (val || this.realTotalTargetData[0].carrierVisibleFlag !== 'Y') {
                setVal();
                this.flag = val;
                return false;
            }
            const flag = this.realTotalTargetData.find((item, index, arr) => item.carrierCode !== arr[0].carrierCode);
            if (flag) {
                this.$message.warning('同一承运商的运单才能排车');
                return false;
            }
            // 点击了排车，已下发供应商
            setVal();
        },
        mousedownTabelHeight (e) {
            this.startMove = e.clientY;
            var distance = 0;
            document.onmousemove = (ev) => {
                var thisEvent = ev || event;
                distance = this.startMove - thisEvent.clientY;
                this.endMove = distance;
                this.$refs.tablePage.targetTableEndMove(this.endMove);
            };
            document.onmouseup = () => {
                document.onmousemove = null;
                document.onmouseup = null;
                this.endMoveHeight = this.endMoveHeight + distance;
            };
        },
        copyText (cellEl, copyText, classFlag) {
            if (cellEl.className.indexOf('el-tooltip') < 0 && classFlag) {
                return;
            }
            var input = document.createElement('input');
            input.type = 'text';
            input.value = copyText.trim();
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$message.success(`‘${input.value}’复制成功`);
        },
        sourceCellDblclick (row, column, cell, event) {
            this.copyText(cell.children[0], cell.children[0].innerHTML, true);
        },
        targetCellDblclick (row, column, cell, event) {
            this.copyText(cell.children[0], cell.children[0].innerHTML, true);
        },
        async totalDataChange (targetData, sourceData, scrollFlag) {
            targetData = targetData.filter((item, index, array) => {
                return array.findIndex(t => t.taskNo === item.taskNo) === index;
            });
            this.mulTotalData = sourceData;
            let btnCount = 0;
            this.mulTotalData.forEach((subItem, subIndex) => {
                if (((subItem.orderType === 'RI') && ['IN', 'DI', 'RDI'].includes(subItem.taskType)) || subItem.projectClassify === 'LW') {
                    subItem.hiddenEvent = ['allocate'];
                } else {
                    btnCount++;
                    subItem.hiddenEvent = [];
                }
            });
            this.config.table.leftOperation = !!btnCount;
            this.realTotalTargetData = await this.initTableData(sortTaskList(targetData || []));
            this.totalTargetData = this.getTotalData(targetData, TARGER_TABLE_MAX_SHOW_COUNT);
            this.totalData = this.getTotalData(sourceData);
        },
        exportFile (submit) { // 导出
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            !this.isFirstSearch && this._validateSearchParams(this._searchData);
            if (this._validateFailed) return false;
            submit({ ...this.exportParams, tenantCode: this.currentTenant.tenantCode });
            this.isFirstSearch = false;
        },
        refreshTargetList () {
            this.totalTargetData = [];
            this.targetTotalListParams.dispatchNo = this.targetTotalListParams.vehicleCard = '';
            this.getTargetList();
            this.$refs.tablePage.initActiveChange();
        },
        async getSiteCodeWhiteList ({ type }) {
            await getWhiteListApi({ type }).then(res => {
                if (res && +res.code === 0) {
                    this.appointmentSiteCodeWhiteList = res.data;
                }
            });
        },
        goToMapLayout () {
            this.$router.push('/distribute/visual-map-layout');
        }
    },
    mounted () {
        this.getDictList();
        this.rowDrop();
        // 强制预约限制白名单
        this.getSiteCodeWhiteList({ type: 'APPOINTMENT_SITE_CODE' });
        this.$refs.tablePage.$refs.searchList.onSearchChange();
    },
    activated () {
        // 强制预约限制白名单
        this.getSiteCodeWhiteList({ type: 'APPOINTMENT_SITE_CODE' });
        if (this.$route.query.transportStatus) {
            this.getRouteQuery();
            this.$refs.tablePage.$refs.searchList.$refs.searchSet[0].setSearchData.createTime=[dayjs().subtract(31, 'day').format('YYYY-MM-DD 00:00:00'),dayjs().format('YYYY-MM-DD 23:59:59')]
            this.$nextTick(() => {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
            });
            return;
        }
        const dispatchNo = this.$route.params.dispatchNo;
        if (dispatchNo) {
            const tablePage = this.$refs.tablePage;
            tablePage.showInput();
            this.autoSearchInput = () => {
                tablePage.input = dispatchNo;
                tablePage.searchInput(null, true);
            };
            if (this.againActivated) {
                this.autoSearchInput();
                this.autoSearchInput = null;
            }
        }
    }
};
</script>
<style lang="less">
@import './dispatchCen.less';
</style>
